exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.panel[data-v-972a093e] {\n  margin-top: 20px;\n}\n.form-group[data-v-972a093e] {\n  margin-bottom: 20px;\n}\n.time-input[data-v-972a093e] {\n  display: flex;\n  align-items: center;\n}\n.time-select[data-v-972a093e] {\n  width: 80px;\n}\nselect[data-v-972a093e] {\n  max-width: 150px;\n}\n.time-separator[data-v-972a093e] {\n  display: inline-block;\n  font-size: 20px;\n  line-height: 34px;\n  font-weight: bold;\n  margin: 0 10px;\n}\n.form-actions[data-v-972a093e] {\n  margin-top: 30px;\n}\n", ""]);

// exports
